module.exports = __webpack_public_path__ + "img/chenggong.6a205cf1.png";